import { render, staticRenderFns } from "./RateIndex.vue?vue&type=template&id=8df99c5c"
import script from "./RateIndex.vue?vue&type=script&lang=ts"
export * from "./RateIndex.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports